import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { ChakraBaseProvider, extendBaseTheme, extendTheme } from "@chakra-ui/react";
import chakraTheme from '@chakra-ui/theme';
import { theme as proTheme } from '@chakra-ui/pro-theme'
import { DevSupport } from "@react-buddy/ide-toolbox";
import { ComponentPreviews, useInitial } from "./dev";
import '@fontsource-variable/open-sans'
import '@fontsource-variable/spline-sans'
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import * as Sentry from "@sentry/react";

import { MainRoutes } from './routes'
import { SENTRY_DSN } from './utils/constants';
import PreferredUnitsProvider from './components/contexts/PreferredUnitsContext';

const router = createBrowserRouter(MainRoutes);

const root = ReactDOM.createRoot(document.getElementById('root'));

const { Button } = chakraTheme.components

const extendedBaseTheme = extendBaseTheme({
    components: {
        Button,
    },
    colors: {
        brand: {
            100: "#00838A",
        },
        teal: {
            aoos: "#00838A",
        }
    }
})

const theme = extendTheme(
    {
        colors: { ...extendedBaseTheme.colors, brand: extendedBaseTheme.colors.blue },
    },
    proTheme,
)

Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
        new Sentry.BrowserTracing(),
        new Sentry.Replay(),
    ],
    environment: process.env.NODE_ENV,
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

root.render(
    <React.StrictMode>
        <ChakraBaseProvider theme={theme}>
            <DevSupport ComponentPreviews={ComponentPreviews}
                useInitialHook={useInitial}
            >
                <RouterProvider router={router} />
            </DevSupport>
        </ChakraBaseProvider>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
